import React from 'react';
import propTypes from 'prop-types';

import { autoShip } from 'apps/cart/paths';
import { TranslatedMessage } from 'common/components/Intl';
import Button from 'common/components/Button';

export default function MembershipInformation(props) {
  const freePackFrequency = (
    <TranslatedMessage
      id={`cart.membership_information.free_frequency`}
      style={`ordinal`}
      values={{ count: props.subscribableVariantFreeFrequency + 1 }}
    />
  );

  return (
    <div className="CartUpsellBanner__information text--body--small">
      <p>
        <TranslatedMessage
          id="cart.membership_information.joining"
          values={{
            minimumPacks: props.minimumSubscriptionItems,
            requiredInstallmentCount: props.requiredInstallmentCount,
            freePackFrequency,
          }}
        />
      </p>

      <p>
        <TranslatedMessage
          id="cart.membership_information.modifying_your_membership"
          values={{
            minimumPacks: props.minimumSubscriptionItems,
            freePackFrequency,
          }}
        />
      </p>

      <Button className="button--outline-soft" element="a" href={autoShip()}>
        <TranslatedMessage id="cart.upsell_banner.learn_more" />
      </Button>
    </div>
  );
}

MembershipInformation.propTypes = {
  minimumSubscriptionItems: propTypes.number.isRequired,
  subscribableVariantFreeFrequency: propTypes.number.isRequired,
  requiredInstallmentCount: propTypes.number,
};
